import { formatAccountNumber, formatCardNumber, formatPhoneNumber } from '@eika-infrastruktur/format';

const formatAmount = (value: number, maximumFractionDigits = 0, addCurrency = false): string => {
    if (typeof value === 'undefined') {
        return '';
    }

    let minimumFractionDigits = 0;

    if (maximumFractionDigits >= 2) {
        minimumFractionDigits = 2;
    }

    const nf = new Intl.NumberFormat('no-NO', { minimumFractionDigits, maximumFractionDigits });
    const numberDisplay = nf.format(value);

    if (addCurrency) {
        return `${numberDisplay} kr`;
    }

    return numberDisplay;
};

export const Format = {
    cardNumber: formatCardNumber,
    accountNumber: (value: string, seperator?: string) => formatAccountNumber({ value }, seperator),
    phoneNumber: formatPhoneNumber,
    amount: formatAmount,
};
